import React from 'react';
import { useStyletron } from 'baseui';
import { TriangleLeft } from 'baseui/icon';

import PasswordTipsList from 'components/UI/ENGTPassword/PasswordTipsList';

import { getPasswordRules } from 'shared/helpers';

export interface INewPasswordWidgetProps {
	value: any;
}
function NewPasswordWidget({ value }: INewPasswordWidgetProps) {
	const [css, theme] = useStyletron();

	const passwordRules = getPasswordRules(value);
	const isPasswordTooltipValid = !!value && passwordRules.isValidLength && passwordRules.hasNonSpaceCharacter;
	const borderColor = theme.colors.inputBorderError;

	if (isPasswordTooltipValid) {
		return null;
	}

	const wrapperCss: any = {
		display: 'flex',
		marginLeft: '0.125rem',
	};

	const ruleWrapperCss: any = {
		backgroundColor: theme.colors.primaryB,
		borderColor,
		borderStyle: 'solid',
		borderWidth: '1px',
		borderRadius: '0.375rem',
		paddingBottom: '0.5rem',
		paddingLeft: '0.625rem',
		paddingRight: '0.625rem',
		paddingTop: '0.5rem',
		boxSizing: 'border-box',
		width: '10.5rem',
	};

	const iconCss: any = {
		alignItems: 'center',
		borderColor,
		borderRadius: '50%',
		borderStyle: 'solid',
		borderWidth: '0.125rem',
		color: borderColor,
		display: 'inline-flex',
		fontSize: '0.75rem',
		fontWeight: 700,
		height: '1.313rem',
		justifyContent: 'center',
		width: '1.313rem',
	};

	const blockCss: any = {
		display: 'flex',
	};

	return (
		<div className={css(wrapperCss)}>
			<span className={css(iconCss)}>i</span>
			<div className={css(blockCss)}>
				<TriangleLeft
					color={borderColor}
					size={20}
					overrides={{
						Svg: {
							style: () => ({
								position: 'relative',
								left: '0.3125rem',
							}),
						},
					}}
				/>
				<div className={css(ruleWrapperCss)}>
					<PasswordTipsList compact value={value} />
				</div>
			</div>
		</div>
	);
}
export default NewPasswordWidget;
